<template>
  <div class="ins-main experience-main">
    <div class="pc_model">
      <div class="ex_head">
        <img src="@img/payment/logo.png" alt="">
      </div>
      <div class="ex_main">
        <div id="back_pay"><router-link to="/payment"><i class="icon-29"></i>{{ $t('lang_quickPayment_backto') }}</router-link></div>
        <ul class="step_bar clearfix">
          <li v-for='(step, i) in 3' :key='step' :class="{'active': i == 0 }">
            <span>{{ i+1 }}</span>
            {{ $t(`lang_quickPayment_step${i+1}`) }}
          </li>
        </ul>
        <span class="ex_promotion">
          {{ $t('lang_quickPayment_desc') }} 
          <i class="btn-reset" @click='reset()' v-show='this.step > 0'>{{ $t('lang_reExperience') }}</i>
        </span>
        <div class="ex_form">
          <div class="ex_row">
            <div class="ex_cell">{{ $t('lang_acc') }}</div>
            <div class="ex_cell">
              <label id="acc_l">
                <input type="text" id="acc" v-model='account' :placeholder="$t('lang_acc_placeholder')">
              </label>
            </div>
          </div>
          <div class="ex_row">
            <div class="ex_cell">{{ $t('lang_deposit') }}</div>
            <div class="ex_cell">
              <label id="money_l">
                <input type="text" id="money" v-model="amount" @click='checkAccount()' :placeholder="$t('lang_deposit_placeholder')">
                <span>{{ $t('lang_deposit_range') }}</span>
              </label>
            </div>
          </div>
          <div class="ex_row" id="pay_list">
            <div class="ex_cell">{{ $t('lang_depositMethod') }}</div>
            <div class="ex_cell">
              <ul class="pay_list">
                <li :class="[{'enable': enablePay == item.name }, {'notuse': !(amount >=item.min && amount <= item.max)}]"
                  v-for='(item, index) in payLists'
                  :key='index' 
                  :data-pay='item.name' 
                  @click='choicePay(item)'>
                  <div><img :src="require(`@img/payment/${item.name}.png`)"><span>{{ $t(`${item.title}`)}}</span></div>
                  <div>{{ $t(`${item.subtitle}`)}}</div>
                  <div>{{ $t(`${item.detail}`)}}</div>
                </li>
              </ul>
            </div>
          </div>
          <div class="ex_row">
            <div class="ex_cell">{{ $t('lang_depositTime') }}</div>
            <div class="ex_cell">
              <label>
                <input type="text" class="time" readonly>
              </label>
            </div>
          </div>
        </div>
        <div class="step_3" v-for='item in payLists' :key='item.anme' :id='item.name'>
          <template v-if="item.name == 'online'">
            <div id="online_price"></div>
          </template>
          <img :src="require(`@img/${nowLangx}/payment/step3_${item.name}.png`)">
        </div>
        <div class="btn-box">
          <span class="sent_btn" @click='send()'>{{ $t('lang_confirm') }}</span>
        </div>
      </div>
    </div>
    <div class="mb_model">
      <div class="ex_m_head">
        <div v-for='item in mHead' :key='item' :class='`m_${item}`'>
          <template v-if='item == "prev"'>
            <router-link to="/payment">
              <img :src="require(`@img/payment/mobile/${item}.png`)" alt="">
            </router-link>
          </template>
          <template v-if='item != "prev"'>
            <router-link to="/"><img :src="require(`@img/payment/mobile/${item}.png`)" alt=""></router-link>
          </template>
        </div>
      </div>
      <div class="ex_m_main">
        <div class="ex_m_main_inner">
          <ul class="step_bar clearfix">
            <li v-for='(step, i) in 3' :key='step' :class="{'active': i == 0 }">
              <span>{{ i+1 }}</span>
              <i>{{ $t(`lang_quickPayment_m_step${i+1}`) }}</i>
            </li>
          </ul>
          <span class="ex_promotion">
            {{ $t('lang_quickPayment_desc') }} 
            <i class="btn-reset" @click='reset()' v-show='this.step > 0'>{{ $t('lang_reExperience') }}</i>
          </span>
          <div class="ex_form">
            <div class="ex_row">
              <div class="ex_cell">{{ $t('lang_acc') }}</div>
              <div class="ex_cell">
                <label id="acc_l">
                  <input type="text" id="acc" v-model='account' :placeholder="$t('lang_acc_placeholder')">
                </label>
              </div>
            </div>
          </div>
          <div class="ex_form">
            <div class="ex_row">
              <div class="ex_cell">{{ $t('lang_deposit') }}</div>
              <div class="ex_cell">
                <label id="money_l">
                  <input type="text" id="money" v-model="amount" @click='checkAccount()' :placeholder="$t('lang_deposit_placeholder')">
                </label>
              </div>
            </div>
          </div>
          <div class="ex_mb_prompt" v-show="exMbPrompt" v-html="$t('lang_deposit_range')"></div>
          <div class="ex_form" v-show='mobilePayList'>
            <div class="ex_row" id="pay_list">
              <div class="ex_cell">{{ $t('lang_depositMethod') }}</div>
              <div class="ex_cell">
                <ul class="pay_list">
                  <li :class="[{'enable': enablePay == item.name }, {'notuse': !(amount >=item.min && amount <= item.max)}]"
                    v-for='(item, index) in payLists'
                    :key='index' 
                    :data-pay='item.name' 
                    @click='choicePay(item)'>
                    <div><img :src="require(`@img/payment/mobile/${item.name}.png`)">{{ $t(`${item.title}`)}}</div>
                    <div>{{ $t(`${item.subtitle}`)}}</div>
                    <div>{{ $t(`${item.detail}`)}}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="ex_form">
            <div class="ex_row">
              <div class="ex_cell">{{ $t('lang_depositTime') }}</div>
              <div class="ex_cell">
                <label>
                  <input type="text" class="time" readonly>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="step_3" v-for='item in payLists' :key='item.anme' :id='item.name'>
          <template v-if="item.name == 'online'">
            <div id="online_price"></div>
          </template>
          <img :src="require(`@img/${nowLangx}/mobile/payment/step3_${item.name}.png`)">
        </div>
        <div class="btn-box">
          <span class="sent_btn" @click='send()'>{{ $t('lang_confirm') }}</span>
        </div>
      </div>
    </div>
    <div class="ex_copyright">{{ $t('lang_footer_copyright') }}</div>
  </div>
</template>

<script>
import $ from 'jquery'
import { mapGetters } from 'vuex'

export default {
    name: 'Experience',
    data() {
      return {
        account: '',
        amount: '',
        enablePay: '',
        step: 0,
        alertArray: [],
        mHead: ['prev', 'logo', 'cs'],
        mobilePayList: false,
        isMobile: false,
        deviceModel: 'pc',
        exMbPrompt: false,
        payLists: [
          {
            
            name: 'online',
            title: 'lang_online_payment',
            subtitle: 'lang_IEbanking',
            detail: 'lang_singleRecord_desc1',
            min: 50,
            max: 20000
          },
          {
            name: 'qq',
            title: 'lang_qq',
            subtitle: 'lang_qq',
            detail: 'lang_singleRecord_desc2',
            min: 10,
            max: 300
          },
          {
            name: 'wechat',
            title: 'lang_wechat',
            subtitle: 'lang_depositMethod_wechat_desc',
            detail: 'lang_singleRecord_desc2',
            min: 10,
            max: 300
          },
          {
            name: 'jd',
            title: 'lang_jd',
            subtitle: 'lang_jd',
            detail: 'lang_singleRecord_desc3',
            min: 10,
            max: 2000
          },
          {
            name: 'pay',
            title: 'lang_pay',
            subtitle: 'lang_pay',
            detail: 'lang_singleRecord_desc3',
            min: 10,
            max: 2000
          }
        ]
      }
    },
    watch: {
      account(val) {
        this.vertifyAccount(val)
      },
      amount(val) { 
        this.vertifyNumber(val)
        this.vertifyPrice(val)
      }
    },
    methods: {
      getTime() {
        const date = new Date()
        const sec = date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds()
        const min = date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()
        const hr = date.getHours() < 10 ? '0'+date.getHours() : date.getHours()
        const time = date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate()+'  '+hr+':'+min+':'+sec
        $('.time').val(time)
        clearTimeout(window['timer'])
        window['timer'] = setTimeout(() => {
          this.getTime()
        }, 1000)
      },
      vertifyAccount(val) {
        if(!val){
          return false;
        }
        let map = 'abcdefghijklmnopqrstuvwxyz0123456789'
        let lowerCase = val.toLowerCase()
        this.step = 0
        this.stepTo()

        // 會員帳號禁止 key in 英數以外的字元
        for(let i = 0; i < lowerCase.length; i++ ) {
          let check = lowerCase.charAt(i);
          this.account = val.toLowerCase();
          if(map.indexOf(check) == -1) {
            this.account = val.replace(check, '')
          }
        }

        // 會員帳號不可超過 12 個字元
        if(val.length > 12) {
          this.account = val.slice(0, 12)
        }

        // 判斷會員帳號如果以 g2e 開頭則打開全部支付方式，反之則打開前三個
        if(val.toLowerCase().indexOf('g2e') != 0) {
          $('.ex_main #pay_list').css('display', 'table-row')
          $('.ex_main .pay_list li[data-pay="jd"],.ex_main .pay_list li[data-pay="pay"]').hide()
          this.mobilePayList = true
          $('.ex_m_main #pay_list').css('display','table-row')
          $('.ex_m_main .pay_list li[data-pay="jd"],.ex_m_main .pay_list li[data-pay="pay"]').removeClass('enable').hide()
        } else {
          $('.ex_main #pay_list').css('display', 'table-row')
          $('.ex_main .pay_list li').show()
          $('.ex_m_main #pay_list').css('display','table-row')
          $('.ex_m_main .pay_list li').show()
          this.mobilePayList = true
        }

        // 會員帳號如果有輸入則出現 √ 符號
        if(val != '') {
          $('.ex_main #acc_l').addClass('veryes')
          $('.ex_m_main #acc_l').addClass('veryes')
        }
      },
      checkAccount() {
        if(!this.account) {
          alert(this.$t('lang_err_accFirst'))
          return
        }
      },
      vertifyNumber(val) {   
        if(!val){
          return false;
        }      
        // 設定存款金額只可 key in 數字
        let map = '0123456789';
        for(let i = 0; i < val.length; i++) {
          let check = val.charAt(i);    
          if(map.indexOf(check) == -1) {
            this.amount = val.replace(check, '')
          }
        }

        // 第一個數字不可為 0
        if(val.charAt(0) == '0' && val.length > 1) {
          this.amount = val.replace(val.charAt(0), '')
        }
        
        if(val == 0) {
          this.amount = '0'
        }

        this.enablePay = null;
      },
      vertifyPrice(val) {
        if(!val){
          return false;
        }
        this.step = 1
        this.stepTo()

        // 判斷金額顯示 √ 或 ✘
        if(val < 10 || val > 20000) {
          $('.ex_main #money_l').removeClass('veryes').addClass('verno').find('span').show()
          $('.ex_m_main #money_l').removeClass('veryes').addClass('verno').find('span').show()
          if(this.deviceModel == 'mb') {this.exMbPrompt = true}
        } else if(val) {
          $('.ex_main #money_l').removeClass('verno').addClass('veryes').find('span').hide()
          $('.ex_m_main #money_l').removeClass('verno').addClass('veryes').find('span').hide()
          this.exMbPrompt = false
        } else {
          this.exMbPrompt = false
        }
      },
      choicePay(item) {
        if(this.amount >= item.min && this.amount <= item.max){
          this.enablePay = item.name
        }
      },
      stepTo() {
        $('.ex_main .step_bar li').eq(this.step).addClass('active')
        $('.ex_m_main .step_bar li').eq(this.step).addClass('active')
        if(this.step > 0) {
          $('.ex_main .step_bar li').eq(this.step - 1).addClass('enable')
        }
      },
      send() {     
        this.alertArray = [];

        if(!this.account) {
          this.alertArray.push(this.$t('lang_err_unAcc'))
        }

        if(!this.amount) {
          this.alertArray.push(this.$t('lang_err_unDeposit'))
        } else {
          if(this.amount < 10) {
            this.alertArray.push(this.$t('lang_err_paymen_below'))
          } else if(this.amount > 20000) {
            this.alertArray.push(this.$t('lang_err_payment_excedd'))
          }
        }

        if(!this.enablePay) {
          this.alertArray.push(this.$t('lang_err_unPayment'))
        }

        if(this.alertArray.length){
          alert(this.alertArray.join('\n'));
          return;
        }

        this.step = 2;
        this.stepTo();
        $('.ex_main .ex_form').hide()
        $('.ex_m_main .ex_form').hide()
        $('.ex_main .step_3#' + this.enablePay).fadeIn()
        $('.ex_m_main .step_3#' + this.enablePay).fadeIn()
        $('.sent_btn').off('click').html(this.$t('lang_completed_scanQrcode')).css('cursor', 'default')
        if(this.enablePay == 'online') {
          $('.sent_btn').html(this.$t('lang_completed_onlineBank'))
          $('.ex_main .step_3 #online_price').html(this.amount)
          $('.ex_m_main .step_3 #online_price').html(this.amount)
        }
        clearTimeout(window['timer'])
        const $this = this
        window['timer'] = setTimeout(function(){
          $this.$router.push('/payment')
        },60000)
      },
      reset() {
        const $this = this
        clearTimeout(window['timer']);
        this.account = this.amount = this.enablePay = null;
        $('.ex_main #money_l').removeClass('verno').removeClass('veryes').find('span').hide()
        $('.ex_m_main #money_l').removeClass('verno').removeClass('veryes').find('span').hide()
        $('.ex_main #acc_l').removeClass('verno').removeClass('veryes').find('span').hide()
        $('.ex_m_main #acc_l').removeClass('verno').removeClass('veryes').find('span').hide()
        $('.ex_main .ex_cell label').removeAttr('class')
        $('.ex_m_main .ex_cell label').removeAttr('class')
        $('.ex_main .pay_list li').removeAttr('class')
        $('.ex_m_main .pay_list li').removeAttr('class')
        $('.ex_main #pay_list').hide()
        this.mobilePayList = false
        $('.ex_m_main #pay_list').hide()
        $('.ex_main .step_bar li').removeAttr('class')
        $('.ex_m_main .step_bar li').removeAttr('class')
        this.step = 0
        this.stepTo()
        $('.ex_main .step_3').hide()
        $('.ex_m_main .step_3').hide()
        $('.ex_main .ex_form').fadeIn()
        $('.ex_m_main .ex_form').fadeIn()
        $('.sent_btn').html(this.$t('lang_confirm')).removeAttr('style').click(function() {
          $this.send()
        });
      },
      getDevice(){
        window.addEventListener('resize',this.windowRes)
        this.windowRes()
      },
      windowRes(){
        const $this = this
        if($this.deviceModel === 'mb' && $(window).width() > 996) {
          $this.isMobile = false
          $this.deviceModel = 'pc'
        }else if ($this.deviceModel === 'pc' && $(window).width() <= 996){
          $this.isMobile = true
          $this.deviceModel = 'mb'
        }  
      },

    },
    computed:{
      ...mapGetters(['nowLangx'])
    },
    mounted() {
      this.getTime()
      this.stepTo()
      this.getDevice()
      this.$store.dispatch('setLoadshow',false)
    },
    beforeDestroy(){
      window.removeEventListener('resize',this.windowRes)
      this.$store.dispatch('setLoadshow',true)
    }
}
</script>

<style lang="sass">
  @import '@css/experience.sass'
</style>

